import { useState } from 'react';
import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const SelectTypeAutocomplete = ({ list, title, name, disabled, handleGetTree }) => {
    // const [value, setValue] = useState(null);
    const [inputValue, setInputValue] = useState('');

    const defaultProps = {
        options: list.map((i) => {
            return { label: i?.text, id: i.id };
        }),
        getOptionLabel: (option) => option?.label,
    };

    const handleClick = (e, info) => {
        handleGetTree(info);
        setInputValue('');
    };

    return (
        <div className="input-select-wrapper">
            <Autocomplete
                onInputChange={(event, newInputValue) => {
                    setInputValue(newInputValue);
                }}
                inputValue={inputValue}
                disabled={disabled}
                {...defaultProps}
                value={null}
                style={{ width: '100%', height: '48px' }}
                onChange={(e, info) => {
                    handleClick(e, info);
                }}
                id="disable-close-on-select"
                name={name}
                renderInput={(params) => <TextField {...params} label={title} variant="outlined" />}
            />
        </div>
    );
};
